export function emailValidate(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function firstCapitalize(string) {
  if (typeof string !== "string") return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatPrice(cents) {
  const price = (cents / 100)
    .toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR"
    })
    .split("\u00a0")
    .map(string => string.split(","))
    .flat();
  return `${price[0]}<sub>,${price[1]}</sub> ${price[2]}`;
}

export function encode(data) {
  const r = Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");
  return r;
}
